import Header from "../standartComponents/header";
import css from "./lesson.module.css";
import LessonBlock from "./lessonBlock";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getVideoLessonById } from "../../lib/videoLessonApi";
import Policies from "../standartComponents/policies";
import Loader from "../standartComponents/loader";

const MainPage = ({ authUser }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [lesson, setLesson] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchLesson = async () => {
      try {
        console.log("ID", id)
        const fetchedLesson = await getVideoLessonById(id);
        console.log("fetchedLesson", fetchedLesson);

        setLesson(fetchedLesson);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchLesson();
  }, [id]);

  useEffect(() => {
    if (!loading && (error || !lesson)) {
      navigate("/404");
    }
  }, [loading, error, lesson, navigate]);

  if (loading) {
    return <Loader />
  }

  return (
    <div className={css.wrapAllM}>
      <Header authUser={authUser} />
      {lesson && <LessonBlock lesson={lesson} authUser={authUser} />}{" "}
      <Policies />
    </div>
  );
};

export default MainPage;
